export class IFRResource {

    errorCode: number;
    
    errorMessage: string;
}
